export const ACCESSORIES = 'Accessories';

export const ACCESSORY_FIELD_NAMES = {
    NAME: 'name',
    INSTALL: 'install',
    SALE: 'sale',
    COST: 'cost',
    INSTALL_PRICE: 'installPrice',
    AMOUNT: 'amount',
    CODE: 'code',
    RESIDUAL: 'residual',
    WE_OWE: 'weOwe',
    PROFIT: 'profit',
    UP_FRONT: 'upFront'
} as const;

export const ACCESSORIES_NUMERIC_MAX_VALUE = 999999;
export const ACCESSORIES_NUMERIC_MAX_VALUE_MESSAGE = 'Value should be less than 1 million.';
export const ACCESSORIES_NUMERIC_MIN_VALUE_MESSAGE = "Value can't be negative.";
export const ACCESSORY_NAME_MAX_LENGTH = 256;

// Label constants used by accessories form components
export const BACK = 'Back';
export const COST = 'Cost';
export const FRONT = 'Front';
export const ID = 'ID';
export const INSTALL = 'Install';
export const NAME = 'Name';
export const PROFIT = 'Profit';
export const REQUIRED = 'Required';
export const REQUIRED_INDICATOR = 'required';
export const RESIDUAL = 'Residual';
export const SALE = 'Sale';
